var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "warning",
    className: "css-1mrdc1e e11k6mr30",
    style: {
      minWidth: 24,
      minHeight: 24
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.857 21.3c0 .35.286.7.714.7h2.858c.428 0 .714-.35.714-.7v-.7H9.857zM12 8c-2.786 0-5 2.17-5 4.9 0 1.68.857 3.15 2.143 3.99v1.61c0 .35.286.7.714.7h4.286c.428 0 .714-.35.714-.7v-1.61C16.143 15.98 17 14.51 17 12.9c0-2.73-2.214-4.9-5-4.9M19 14h3v-2h-3zm-8-8h2V3h-2zm-6 8H2v-2h3zm1.698-5.395 1.407-1.407-2.12-2.121-1.408 1.407zm12.718-2.114-2.121 2.122-1.407-1.408 2.12-2.12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.228aa716e0db92354815eedffe936572.svg";
export { ForwardRef as ReactComponent };